export const apiUrls = {
 login: "login",
 forgotpassword:"forgot-password",
 verifyresetotp:"verify-reset-otp",
 resetpassword:"reset-password",
 contactus  :"contact-us",
 verifyotp:"verify-otp",
 resendotp:"resend-otp",
 register:"register",
 changepassword:"change-password",
 profile:"profile",
 updateProfile:"update-profile",
 skilltypes:"skill-types",
 trainingtypes:"training-types",
 skillvideos:"skill-videos",
 trainingvideos:"training-videos",
 markvideocompleted:"mark-video-completed",
 coachsummarydetail:"coach-summary-detail",
 deleteaccount:"delete-account",
 skillvideodetails:"skill-video-details",
 challengedetails:"challenge-details",
 addvideotopersonalized:"add-video-to-personalized",
 addskilltopersonalized:"add-skill-to-personalized",
 personaltrainingsession:"personal-training-session",
 challenges:"challenges",
 ratingtracker:"rating-tracker",
 updateratingtracker:"update-rating-tracker",
 ratingtrackerlist:"rating-tracker-list",
 canaddmatch:"can-add-match",
 deleteratingtracker:"delete-rating-tracker",
 ratingtrackerdetail:"rating-tracker-detail",
 getuser:"get-user",
 myinvitations:"my-invitations",
 banners:"banners",
 respondinvitation:"respond-invitation",
 userdetail:"user-detail",
 storetraining:"store-training",
 gettraining:"get-training",
 deletetraining:"delete-training",
 detailtraining:"detail-training",
 allocatedtrainingdetail:"allocated-training-detail",
 updatetraining:"update-training",
 assignplayers:"assign-players",
 assignteamplayers:"assign-team-players",
 allocatedtrainings:"allocated-trainings",
 sendinvitation:"send-invitation",
 myteam:"my-team",
 coachsummary:"coach-summary",
 getnotifications:"get-notifications",
 quiztypes:"quiz-types",
 trophies:"trophies",
 quizzes:"quizzes",
 questions:"questions",
 review:"review",
 quizzessubmit:"submit",
 trophydetail:"trophy-detail",
 redeemtrophy:"redeem-trophy",
 markskillvideocompleted:"mark-skill-video-completed",
 allocatedtrainingcompleted:"allocated-training-completed",
 pointshistory:"points-history",
 redeemhistory:"redeem-history",
 sendemailinvitation:"send-email-invitation",
 storeteam:"store-team",
 getteam:"get-team",
 updateteam:"update-team",
 detailteam:"detail-team",
 deleteteam:"delete-team",
 deletegroup:"delete-group",
 dashboarddetails:"dashboard-details",
 details:"details",
 coachnotification:"coach-notification",
 openchat:"open-chat",
 sendmessage:"send-message",
 marknotification:"mark-notification",
 togglefavouritechallenge:"toggle-favourite-challenge",
 favourites:"favourites",
 storechallengenote:"store-challenge-note",
 getchallengenotes:"get-challenge-notes",
 deletechallengenote:"delete-challenge-note",
 updatechallengenote:"update-challenge-note",
 allchallengenotes:"all-challenge-notes",
 storeskillnote:"store-skill-note",
 getskillnotes:"get-skill-notes",
 updateskillnote:"update-skill-note",
 deleteskillnote:"delete-skill-note",
 allskillnotes:"all-skill-notes",
 programvideos:"program-videos",
 getcoachteams:"get-coach-teams",
 stripecheckout:"stripe/checkout",
 stripeverifysession:"stripe/verify-session",
 myplanhistory:"my-plan-history",
 myplan:"my-plan",
 plans:"plans",
 tourvideos:"tour-videos",
 programskilltypes:"program-skill-types",
 programskillvideos:"program-skill-videos",
 videoupload:"video-upload",
  videoUploadInitiate: 'video-upload/initiate',
  videoUploadPartUrls: 'video-upload/part-urls',
  videoUploadComplete: 'video-upload/complete',
  videoUploadAbort: 'video-upload/abort',
 nexttrainingvideo:"next-training-video",
 unreadcount:"unread-count",
 sendinvitationtocoach:"send-invitation-to-coach",
 myinvitationscoach:"my-invitations-coach",
 respondinvitationcoach:"respond-invitation-coach",
 checkcoachconnection: "check-coach-connection",
};
